let menuTrigger = document.querySelector(".header__mobileMenuTrigger");
let header = document.querySelector(".header");
let body = document.querySelector("body");
let navToggle = '<span class="mobile-menu__sub-menu-toggle"><svg xmlns="http://www.w3.org/2000/svg" class="mobile-menu__arrow" viewBox="0 0 11 6"><path fill="currentColor" fill-rule="evenodd" d="M10.301 5.15c0-.079-.026-.159-.106-.238L5.39.106A.326.326 0 0 0 5.15 0c-.079 0-.159.026-.238.106L.106 4.912A.326.326 0 0 0 0 5.15c0 .079.026.16.106.239l.504.504a.322.322 0 0 0 .478 0L5.151 1.83l4.062 4.063c.08.079.16.106.239.106.08 0 .16-.026.239-.106l.504-.504c.053-.08.106-.16.106-.24Z"/></svg></span>';

function createDropDownHeader(element, title, permalink) {
  let headerElement = `<div class="main-menu__sub-menu__header">
    <button class="main-menu__sub-menu__headerClose">
    <svg xmlns="http://www.w3.org/2000/svg" class="mobile-menu__arrow" viewBox="0 0 11 6"><path fill="currentColor" fill-rule="evenodd" d="M10.301 5.15c0-.079-.026-.159-.106-.238L5.39.106A.326.326 0 0 0 5.15 0c-.079 0-.159.026-.238.106L.106 4.912A.326.326 0 0 0 0 5.15c0 .079.026.16.106.239l.504.504a.322.322 0 0 0 .478 0L5.151 1.83l4.062 4.063c.08.079.16.106.239.106.08 0 .16-.026.239-.106l.504-.504c.053-.08.106-.16.106-.24Z"></path></svg> Menu
    </button>
    </div>
    <li class="main-menu__sub-menu__item main-menu__sub-menu__item-heading"><div class="main-menu__sub-menu__link">${title}</div></li>`
  element.insertAdjacentHTML("afterbegin", headerElement);
}

function manipulateMenu() {
  Array.prototype.forEach.call(document.querySelectorAll('.mobile-menu__item--parent'), function (trigger) {
    trigger.firstElementChild.insertAdjacentHTML("afterend", navToggle);
    createDropDownHeader(trigger.lastElementChild, trigger.firstElementChild.innerHTML, trigger.firstElementChild.href);

    const dropdown = trigger.lastElementChild;
    const dropdownClose = dropdown.firstElementChild.firstElementChild;

    dropdownClose.addEventListener('mouseenter', () => {
      dropdown.classList.remove('mobile-menu__sub-menu--active');
    });

    menuTrigger.addEventListener('mouseenter', () => {
      dropdown.classList.remove('mobile-menu__sub-menu--active');
    });

    trigger.children[1].addEventListener('mouseenter', (e) => {
        if (dropdown.classList.contains('mobile-menu__sub-menu--active')) {
          return true;
        } else {
          e.preventDefault();
          dropdown.classList.add('mobile-menu__sub-menu--active');
        }
    });

  });
}

function toggleMenu() {
  header.classList.toggle("header--menuActive");
  body.classList.toggle("mobile-menu-is-open");
  menuTrigger.classList.toggle('header__mobileMenuTrigger--opened');
};

const Menu = () => {
  if (typeof menu != "undefined" && menu != null);
  manipulateMenu();

  menuTrigger.addEventListener("mouseenter", () => toggleMenu());

}

export default Menu;


// WEBPACK FOOTER //
// ./src/js/app/components/Menu.js